import React, {Component} from 'react';
import {Icon, Input} from 'antd';
import './SAInput.css';
import {injectIntl} from "react-intl";
import FieldError from "./FieldError";

class SAInput extends Component {

  render() {
    const {error, icon, name, onChange, placeholder, type, value, ...attributes } = this.props;

    const prefix = icon ? (<Icon type={icon} style={{ color: 'rgba(0,0,0,.25)' }} />) : null;

    return (
      <div className={error ? " error":''}>
          <Input prefix={prefix}
                 type={type}
                 name={name}
                 id={name}
                 placeholder={placeholder}
                 value={value}
                 onChange={onChange}
                 {...attributes}
          />
          {error && (
            <FieldError error={error}/>
          )}
      </div>
    );
  }
}

export default injectIntl(SAInput);



// WEBPACK FOOTER //
// ./src/components/common/input/SAInput.js